module.exports = __webpack_public_path__ + "img/secureExportImage.0a2e470c.svg";